import React from "react";
import { Modal } from "antd";

export const ERROR = props => {
  console.log("ERROR", props);
  return (
    <div>
      {Modal.error({
        title: "Error",
        content: props
      })}
    </div>
  );
};

export const Warning = props => {
  Modal.warning({
    title: "Warning",
    content: props
  });
};

export const Success = (props) => {
  Modal.success({
    title: "Success",
    content: props
  });
};
